export enum THEME_MODE {
  light = 'light',
  dark = 'dark',
}
